import request from '@/utils/request'

export function getList(params){
   return request.get('dw/promoteUsers/list',params)
}
export function creatBatchList(data){
    return request.post('dw/promoteUsers/creatBatchList',data)
 }
 export function bindUsers(data){
    return request.post('dw/promoteUsers/bindUsers',data)
 }

 export function userList(params){
   return request.get('/dw/promoteUsers/userList',params)
 }

 export function checkPermision(data){
   return request.post('/dw/promoteUsers/authUserInfo',data)
 }

 export function getLoginStatus(){
   return request.get('/dw/promoteUsers/getLoginStatus')
 }
 export function getLowerUserList(code,params){
   return request.get(`/dw/promoteUsers/getLowerUserList/${code}`,params)
 }

 

 

 